import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const exportJsonFail = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:jsonfailed`, 
        category: settings.categoryName 
    });
};

export default exportJsonFail;